import React from 'react'
import { Link } from 'react-router-dom'
import { ERP_SYNC_STATUSES } from 'utils/constants'
import { setDecimalPrecision } from 'utils/helpers'
import { syncObjectTypes } from 'components/containers/ledger/utils'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
import DataGridWithSearch from './DataGridWithSearch'

const getColumns = () => [
  {
    field: 'ticketNumber',
    headerName: '#',
    renderCell: params => (
      <Link to={`${params.row.redirectUrl}`} target="_blank">
        {params.row.ticketNumber}
      </Link>
    ),
  },
  {
    field: 'objectType',
    headerName: 'Object Type',
    flex: 1,
    renderCell: params => {
      const { row } = params
      const syncObject = syncObjectTypes[row.objectType]
      if (syncObject) {
        const qualifier = row.itemsLinked.length > 1 ? ` (${row.itemsLinked.length})` : ''
        return `${syncObject.name}${qualifier}`
      }
      return ''
    },
  },
  {
    field: 'syncStatus',
    headerName: 'Sync Type',
    flex: 1,
    renderCell: params => {
      const value = params?.row?.syncStatus
      if (!Object.keys(value).length) return 'New'
      switch (value.syncStatus) {
        case ERP_SYNC_STATUSES.FAILED:
          return (
            <>
              Retry from&nbsp;
              <Link to={`/app/ledger/sync-log/${value?.batchNumber}`}>{`Batch #${value?.perYardBatchNumber}`}</Link>
            </>
          )
        case ERP_SYNC_STATUSES.COMPLETED_BY_SYSTEM:
          return 'Update'
        default:
          return '-'
      }
    },
  },
  {
    field: 'customer',
    headerName: 'Customer',
    flex: 1,
  },
  {
    field: 'dateCreated',
    headerName: 'Date Created',
    flex: 1,
    renderCell: params => {
      const { row } = params
      return row.dateCreated ? dateFormatter(row.dateCreated) : '--'
    },
  },
  {
    field: 'value',
    headerName: 'Value',
    flex: 1,
    headerAlign: 'right',
    align: 'right',
    renderCell: params => {
      const {
        row: { itemsLinked, value, pricePrepend },
      } = params
      if (itemsLinked.length > 1) {
        const total = itemsLinked.reduce((acc, next) => acc + next.data.total, 0)
        return `${pricePrepend}${setDecimalPrecision(total, { decimalPrecisionOverride: 2 })}`
      }
      return value
    },
  },
]

const LedgerSyncGrid = props => {
  return <DataGridWithSearch {...props} columns={getColumns()} textSearchPlaceholder="Search for anything" />
}

LedgerSyncGrid.propTypes = DataGridWithSearch.propTypes

LedgerSyncGrid.defaultProps = DataGridWithSearch.defaultProps

export default LedgerSyncGrid
